import styled from '@emotion/styled';

const DialogContentWrapper = styled('section')({
  minWidth: '100%',
  maxWidth: '100%',
  flex: 1,
});

export default DialogContentWrapper;
